import { Box, Stack } from "@mui/joy";
import { QRCodeSVG } from "qrcode.react";
import CommonModal from "../../../common/CommonModal";
import DarkTypography from "../../../common/DarkTypography";
import { SAndroid } from "../../../../styles/StyledMUI";
import { colorTokens, withAlpha } from "../../../../styles/globalStyles";

export const MOBILE_APK_DOWNLOAD_URL =
  "https://s3.fr-par.scw.cloud/karapaz-files/react-zekay-mobile/builds/latest/app-release.apk";

type ApkDownloadModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function ApkDownloadModal({ open, onClose }: ApkDownloadModalProps) {
  return (
    <CommonModal open={open} onClose={onClose} title="APK Android" size="sm" fitContentHeight>
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            width: "100%",
            padding: 1.5,
            borderRadius: 8,
            backgroundColor: withAlpha(colorTokens.accent.primary, 0.08),
            border: `1px solid ${withAlpha(colorTokens.accent.primary, 0.18)}`,
          }}
        >
          <SAndroid sx={{ fontSize: 24, color: colorTokens.accent.primary, flexShrink: 0 }} />
          <DarkTypography level="body-sm" colorVariant="primary">
            Scannez ce QR avec le téléphone pour installer l'app.
          </DarkTypography>
        </Box>

        <Box
          sx={{
            padding: 2,
            backgroundColor: "#ffffff",
            borderRadius: 12,
          }}
        >
          <QRCodeSVG value={MOBILE_APK_DOWNLOAD_URL} size={220} level="M" includeMargin={false} />
        </Box>
      </Stack>
    </CommonModal>
  );
}
